// components/Membres.js
import React, { useEffect, useState, useCallback } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { MdDeleteForever } from "react-icons/md";
import ImageViewer from 'react-simple-image-viewer';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import VideoThumbnail from './VideoThumbnail';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ImageTileComponent from './ImageTileComponent';
//a




function ImageScoreComponent(props) {
  const [data, setData] = useState(props.data);


  //Modal
  const [show, setShow] = useState(false);
  const [enableError, setEnableError] = useState(false);

  const handleClose = () => {
    setShow(false)
    setActiveFilename("")
  };

  const handleConfirm = async () => {
    try {
      const response = await axios.delete(`/api/defisuploads/${activeFilename}`);
      if (response.status === 200) {
        //console.log(response.data);
        //console.log('File deleted successfully');
        setData((prevImages) => prevImages.filter((image) => image.filename !== activeFilename));
        setShow(false)
      }
    } catch (error) {
      handleError(error);
    }

  };

  const handleError = (error) => {
    setErrorMessage(error)
    setEnableError(true)
  };

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [activeFilename, setActiveFilename] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorColor, setErrorColor] = useState("black");


  const openImageViewer = useCallback((filename, index) => {
    setImages([filename])
    setCurrentImage(0);
    //setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const handleClick = (filename, index) => {
    //alert("Delte file" + filename);
    setShow(true);
    setActiveFilename(filename);
  };

  const handleScoreSubmit = async (defiId, patrouilleId, score) => {
    try {
      await axios.post('/api/score/add', {
        defiId,
        patrouilleId,
        score
      });
      setErrorMessage('Score submitted successfully');
      setErrorColor('green');
    } catch (error) {
      console.error('Error submitting score:', error);
      setErrorMessage('Failed to submit score');
      setErrorColor('red');

    }
  };

  return (

    <Row>
      <h3>{data.districtName}</h3>
      <h4>
        {data.name
          ? `${data.groupe} - ${data.name}`
          : data.groupe}
      </h4>
      <h5>{data.totem}</h5>
      {data.graded == true && <h5 style={{ color: 'blue' }}>- {data.score} pts</h5>}
      <ImageTileComponent data={data.files} />
      <div className="mb-3" style={{ display: "flex", gap: "5px" }}>
        {Array.from({ length: props.points }, (_, i) => (
          <Button
            key={i}
            variant="success"
            size="sm"
            onClick={() => handleScoreSubmit(props.defiId, data.patrouilleId, i + 1)}
          >
            {i + 1}
          </Button>
        ))}
      </div>
      <p style={{ color: errorColor }}>{errorMessage}</p>
      <hr style={{ width: '100%', borderTop: '1px solid #000', marginBottom: '30px' }} />


    </Row>
  );
}



export default ImageScoreComponent;